import React from 'react';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';

const ProviderCard = ({ provider, roleLabel, onEdit, onArchive, onLink = null }) => (
  <Card variant="outlined" sx={{ opacity: provider.isActive ? 1 : 0.72 }}>
    <CardContent>
      <Stack direction="row" spacing={1} alignItems="flex-start" justifyContent="space-between">
        <Box sx={{ minWidth: 0 }}>
          <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
            <Typography variant="h6" sx={{ fontWeight: 800 }}>
              {provider.name}
            </Typography>
            <Chip size="small" label={roleLabel} />
            {provider.isActive ? (
              <Chip size="small" color="success" variant="outlined" label="Active" />
            ) : (
              <Chip size="small" color="default" variant="outlined" label="Inactive" />
            )}
          </Stack>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
            {[provider.specialty, provider.organizationName].filter(Boolean).join(' · ') || 'No specialty or organization yet'}
          </Typography>
        </Box>
      </Stack>

      <Divider sx={{ my: 1.5 }} />

      <Stack spacing={0.5}>
        {provider.phone ? <Typography variant="body2">Phone: {provider.phone}</Typography> : null}
        {provider.email ? <Typography variant="body2">Email: {provider.email}</Typography> : null}
        {provider.address ? <Typography variant="body2">Address: {provider.address}</Typography> : null}
        {provider.notes ? <Typography variant="body2">Notes: {provider.notes}</Typography> : null}
      </Stack>
    </CardContent>

    <CardActions sx={{ px: 2, pb: 2 }}>
      {onLink ? (
        <Button variant="contained" onClick={onLink}>
          Link
        </Button>
      ) : null}
      <Button startIcon={<EditIcon />} onClick={onEdit}>
        Edit
      </Button>
      {provider.isActive ? (
        <Button startIcon={<PauseCircleOutlineIcon />} onClick={onArchive}>
          Mark inactive
        </Button>
      ) : null}
    </CardActions>
  </Card>
);

export default ProviderCard;
